import { render, staticRenderFns } from "./qxTwo.vue?vue&type=template&id=018e15c6"
import script from "./qxTwo.vue?vue&type=script&lang=js"
export * from "./qxTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports